import { IntlShape } from 'react-intl';
import { SuggesterSection } from '@rossum/components/variable-suggestions/Suggester';
import { VariableCompletion } from '@rossum/components/variable-suggestions/types';
import { baseCompletions } from './FormulaEditor/completers/completions';
import { contextSections } from './FormulaEditor/completers/contextSideloads';

type BaseSectionKey =
  | 'fields'
  | 'dataset'
  | 'annotation'
  | 'document'
  | 'email';

const baseTitle = (intl: IntlShape, key: BaseSectionKey) =>
  intl.formatMessage({ id: `features.formulas.suggester.${key}` });

export const baseSuggesterSections = (
  intl: IntlShape,
  items: { fields?: VariableCompletion[]; dataset?: VariableCompletion[] } = {}
): Record<BaseSectionKey, SuggesterSection> => ({
  fields: {
    key: 'fields',
    title: baseTitle(intl, 'fields'),
    items: items.fields ?? [],
    variant: 'fields',
  },
  dataset: {
    key: 'dataset',
    title: baseTitle(intl, 'dataset'),
    items: items.dataset ?? [],
    variant: 'dataset',
  },
  annotation: {
    key: 'annotation',
    title: baseTitle(intl, 'annotation'),
    items: baseCompletions.annotation,
  },
  document: {
    key: 'document',
    title: baseTitle(intl, 'document'),
    items: baseCompletions.document,
  },
  email: {
    key: 'email',
    title: baseTitle(intl, 'email'),
    items: baseCompletions.email,
  },
});

export const contextSuggesterSections = (intl: IntlShape): SuggesterSection[] =>
  contextSections.map(section => ({
    key: section.key,
    title: intl.formatMessage({
      id: `features.formulas.suggester.${section.key}`,
    }),
    items: section.items,
  }));
